<template>
  <section
    class="px-10 py-10 lg:px-16 lg:py-20 sm-max:px-5 testimonials lg:min-h-[758px] md:min-h-[646px] min-h-[594px]"
    style="background-color: #F5F5F5">
    <div class="relative" :class="MobileNoSlider ? 'xl:px-10 px-2' : 'px-6 lg:px-10'">

      <h3 class="font-bold text-center font-ww-medium" v-html="headerText"
        :class="MobileNoSlider ? 'xl:text-4xl md:text-3xl text-4xl' : 'xl:text-4xl md:text-3xl text-2xl'">
      </h3>

      <ClientOnly>
        <!-- Static Mobile View -->
        <div v-if="MobileNoSlider && isMobile" class="grid grid-cols-1 gap-12 mt-8 md:hidden">
          <div v-for="slide in slides" :key="slide.name" class="text-center">
            <nuxt-img class="m-auto w-full rounded-lg" loading="lazy" format="webp" width="460" height="259"
              :alt="slide.imgAlt" :src="slide.imgSrc" />
            <div class="mt-3 md:mt-6" :class="MobileNoSlider ? 'md-max:mt-6' : ''">
              <svg class="mx-auto" width="162" height="33" viewBox="0 0 162 33" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.2741 5.92728C14.8803 4.06162 17.5197 4.06162 18.1259 5.92728L19.3825 9.79468C19.6536 10.629 20.4311 11.1939 21.3084 11.1939H25.3748C27.3365 11.1939 28.1521 13.7041 26.5651 14.8572L23.2753 17.2474C22.5655 17.763 22.2685 18.677 22.5396 19.5114L23.7962 23.3788C24.4024 25.2445 22.2671 26.7959 20.6801 25.6428L17.3903 23.2526C16.6805 22.737 15.7195 22.737 15.0097 23.2526L11.7199 25.6428C10.1329 26.7959 7.99758 25.2445 8.60377 23.3788L9.86036 19.5114C10.1315 18.677 9.83448 17.763 9.12474 17.2474L5.83493 14.8572C4.24791 13.7041 5.06353 11.1939 7.02519 11.1939H11.0916C11.9689 11.1939 12.7464 10.629 13.0175 9.79468L14.2741 5.92728Z"
                  fill="#FF8B01" />
                <path
                  d="M46.6725 5.92728C47.2787 4.06162 49.9181 4.06162 50.5243 5.92728L51.7809 9.79468C52.052 10.629 52.8295 11.1939 53.7068 11.1939H57.7732C59.7349 11.1939 60.5505 13.7041 58.9635 14.8572L55.6737 17.2474C54.964 17.763 54.667 18.677 54.9381 19.5114L56.1947 23.3788C56.8009 25.2445 54.6655 26.7959 53.0785 25.6428L49.7887 23.2526C49.079 22.737 48.1179 22.737 47.4082 23.2526L44.1184 25.6428C42.5313 26.7959 40.396 25.2445 41.0022 23.3788L42.2588 19.5114C42.5299 18.677 42.2329 17.763 41.5232 17.2474L38.2334 14.8572C36.6463 13.7041 37.462 11.1939 39.4236 11.1939H43.4901C44.3673 11.1939 45.1449 10.629 45.416 9.79468L46.6725 5.92728Z"
                  fill="#FF8B01" />
                <path
                  d="M79.0749 5.92728C79.6811 4.06162 82.3205 4.06162 82.9267 5.92728L84.1833 9.79468C84.4544 10.629 85.2319 11.1939 86.1092 11.1939H90.1756C92.1373 11.1939 92.9529 13.7041 91.3659 14.8572L88.076 17.2474C87.3663 17.763 87.0693 18.677 87.3404 19.5114L88.597 23.3788C89.2032 25.2445 87.0679 26.7959 85.4809 25.6428L82.191 23.2526C81.4813 22.737 80.5203 22.737 79.8105 23.2526L76.5207 25.6428C74.9337 26.7959 72.7984 25.2445 73.4046 23.3788L74.6611 19.5114C74.9322 18.677 74.6353 17.763 73.9255 17.2474L70.6357 14.8572C69.0487 13.7041 69.8643 11.1939 71.826 11.1939H75.8924C76.7697 11.1939 77.5472 10.629 77.8183 9.79468L79.0749 5.92728Z"
                  fill="#FF8B01" />
                <path
                  d="M111.473 5.92728C112.08 4.06162 114.719 4.06162 115.325 5.92728L116.582 9.79468C116.853 10.629 117.63 11.1939 118.508 11.1939H122.574C124.536 11.1939 125.351 13.7041 123.764 14.8572L120.474 17.2474C119.765 17.763 119.468 18.677 119.739 19.5114L120.995 23.3788C121.602 25.2445 119.466 26.7959 117.879 25.6428L114.589 23.2526C113.88 22.737 112.919 22.737 112.209 23.2526L108.919 25.6428C107.332 26.7959 105.197 25.2445 105.803 23.3788L107.06 19.5114C107.331 18.677 107.034 17.763 106.324 17.2474L103.034 14.8572C101.447 13.7041 102.263 11.1939 104.224 11.1939H108.291C109.168 11.1939 109.946 10.629 110.217 9.79468L111.473 5.92728Z"
                  fill="#FF8B01" />
                <path
                  d="M143.876 5.92728C144.482 4.06162 147.121 4.06162 147.727 5.92728L148.984 9.79468C149.255 10.629 150.033 11.1939 150.91 11.1939H154.976C156.938 11.1939 157.754 13.7041 156.167 14.8572L152.877 17.2474C152.167 17.763 151.87 18.677 152.141 19.5114L153.398 23.3788C154.004 25.2445 151.869 26.7959 150.282 25.6428L146.992 23.2526C146.282 22.737 145.321 22.737 144.611 23.2526L141.321 25.6428C139.734 26.7959 137.599 25.2445 138.205 23.3788L139.462 19.5114C139.733 18.677 139.436 17.763 138.726 17.2474L135.436 14.8572C133.849 13.7041 134.665 11.1939 136.627 11.1939H140.693C141.57 11.1939 142.348 10.629 142.619 9.79468L143.876 5.92728Z"
                  fill="#FF8B01" />
              </svg>
            </div>
            <div class="pt-3 mb-4 md:pt-6 font-ww-regular xl:px-4" v-html="slide.testimonial"
              :class="MobileNoSlider ? 'text-lg md-max:!leading-6 md-max:pt-5 md-max:px-0' : 'md:text-lg text-base md-max:px-4'">
            </div>
            <h3 class="font-bold leading-6 md:text-lg font-ww-bold"
              :class="MobileNoSlider ? 'text-lg md-max:mb-2' : 'text-base md:text-lg'" v-html="slide.name"></h3>
            <h4 class="leading-4 font-ww-regular" :class="MobileNoSlider ? 'text-lg' : 'text-base md:text-lg'">{{
              slide.title }}</h4>
          </div>
        </div>

        <Swiper v-else :class="'relative overflow-hidden mt-12 md-max:mt-6'"
          :autoplay="{ delay: 4000, disableOnInteraction: true, pauseOnMouseEnter: true, }" :autoHeight="false"
          :modules="[SwiperNavigation, SwiperAutoplay]" :slidesPerView="1" :spaceBetween="73" :loop="true" :navigation="{
            nextEl: '.swiper-button-next-1',
            prevEl: '.swiper-button-prev-1'
          }" :breakpoints="{
            768: { slidesPerView: 2, },
          }">
          <SwiperSlide v-for="slide in slides" :key="slide.name">
            <div class="text-center">
              <nuxt-img class="m-auto w-full rounded-lg" loading="lazy" format="webp" width="460" height="259"
                :alt="slide.imgAlt" sizes="sm:440px  md:100vw lg:100vw xl:460px" :src="slide.imgSrc" />
              <div class="mt-3 md:mt-6" :class="MobileNoSlider ? 'md-max:mt-6' : ''">
                <svg class="mx-auto" width="162" height="33" viewBox="0 0 162 33" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.2741 5.92728C14.8803 4.06162 17.5197 4.06162 18.1259 5.92728L19.3825 9.79468C19.6536 10.629 20.4311 11.1939 21.3084 11.1939H25.3748C27.3365 11.1939 28.1521 13.7041 26.5651 14.8572L23.2753 17.2474C22.5655 17.763 22.2685 18.677 22.5396 19.5114L23.7962 23.3788C24.4024 25.2445 22.2671 26.7959 20.6801 25.6428L17.3903 23.2526C16.6805 22.737 15.7195 22.737 15.0097 23.2526L11.7199 25.6428C10.1329 26.7959 7.99758 25.2445 8.60377 23.3788L9.86036 19.5114C10.1315 18.677 9.83448 17.763 9.12474 17.2474L5.83493 14.8572C4.24791 13.7041 5.06353 11.1939 7.02519 11.1939H11.0916C11.9689 11.1939 12.7464 10.629 13.0175 9.79468L14.2741 5.92728Z"
                    fill="#FF8B01" />
                  <path
                    d="M46.6725 5.92728C47.2787 4.06162 49.9181 4.06162 50.5243 5.92728L51.7809 9.79468C52.052 10.629 52.8295 11.1939 53.7068 11.1939H57.7732C59.7349 11.1939 60.5505 13.7041 58.9635 14.8572L55.6737 17.2474C54.964 17.763 54.667 18.677 54.9381 19.5114L56.1947 23.3788C56.8009 25.2445 54.6655 26.7959 53.0785 25.6428L49.7887 23.2526C49.079 22.737 48.1179 22.737 47.4082 23.2526L44.1184 25.6428C42.5313 26.7959 40.396 25.2445 41.0022 23.3788L42.2588 19.5114C42.5299 18.677 42.2329 17.763 41.5232 17.2474L38.2334 14.8572C36.6463 13.7041 37.462 11.1939 39.4236 11.1939H43.4901C44.3673 11.1939 45.1449 10.629 45.416 9.79468L46.6725 5.92728Z"
                    fill="#FF8B01" />
                  <path
                    d="M79.0749 5.92728C79.6811 4.06162 82.3205 4.06162 82.9267 5.92728L84.1833 9.79468C84.4544 10.629 85.2319 11.1939 86.1092 11.1939H90.1756C92.1373 11.1939 92.9529 13.7041 91.3659 14.8572L88.076 17.2474C87.3663 17.763 87.0693 18.677 87.3404 19.5114L88.597 23.3788C89.2032 25.2445 87.0679 26.7959 85.4809 25.6428L82.191 23.2526C81.4813 22.737 80.5203 22.737 79.8105 23.2526L76.5207 25.6428C74.9337 26.7959 72.7984 25.2445 73.4046 23.3788L74.6611 19.5114C74.9322 18.677 74.6353 17.763 73.9255 17.2474L70.6357 14.8572C69.0487 13.7041 69.8643 11.1939 71.826 11.1939H75.8924C76.7697 11.1939 77.5472 10.629 77.8183 9.79468L79.0749 5.92728Z"
                    fill="#FF8B01" />
                  <path
                    d="M111.473 5.92728C112.08 4.06162 114.719 4.06162 115.325 5.92728L116.582 9.79468C116.853 10.629 117.63 11.1939 118.508 11.1939H122.574C124.536 11.1939 125.351 13.7041 123.764 14.8572L120.474 17.2474C119.765 17.763 119.468 18.677 119.739 19.5114L120.995 23.3788C121.602 25.2445 119.466 26.7959 117.879 25.6428L114.589 23.2526C113.88 22.737 112.919 22.737 112.209 23.2526L108.919 25.6428C107.332 26.7959 105.197 25.2445 105.803 23.3788L107.06 19.5114C107.331 18.677 107.034 17.763 106.324 17.2474L103.034 14.8572C101.447 13.7041 102.263 11.1939 104.224 11.1939H108.291C109.168 11.1939 109.946 10.629 110.217 9.79468L111.473 5.92728Z"
                    fill="#FF8B01" />
                  <path
                    d="M143.876 5.92728C144.482 4.06162 147.121 4.06162 147.727 5.92728L148.984 9.79468C149.255 10.629 150.033 11.1939 150.91 11.1939H154.976C156.938 11.1939 157.754 13.7041 156.167 14.8572L152.877 17.2474C152.167 17.763 151.87 18.677 152.141 19.5114L153.398 23.3788C154.004 25.2445 151.869 26.7959 150.282 25.6428L146.992 23.2526C146.282 22.737 145.321 22.737 144.611 23.2526L141.321 25.6428C139.734 26.7959 137.599 25.2445 138.205 23.3788L139.462 19.5114C139.733 18.677 139.436 17.763 138.726 17.2474L135.436 14.8572C133.849 13.7041 134.665 11.1939 136.627 11.1939H140.693C141.57 11.1939 142.348 10.629 142.619 9.79468L143.876 5.92728Z"
                    fill="#FF8B01" />
                </svg>
              </div>
              <div class="pt-3 mb-4 text-base md:pt-6 md-max:px-4 font-ww-regular md:text-lg xl:px-4"
                v-html="slide.testimonial"></div>
              <h3 class="font-bold leading-6 md:text-lg font-ww-bold"
                :class="MobileNoSlider ? 'text-lg md-max:mb-2' : 'text-base md:text-lg'" v-html="slide.name"></h3>
              <h4 class="leading-4 font-ww-regular" :class="MobileNoSlider ? 'text-lg' : 'text-base md:text-lg'">{{
                slide.title }}</h4>
            </div>
          </SwiperSlide>

        </Swiper>

        <div v-if="!MobileNoSlider || !isMobile"
          class="absolute sm:-left-0 left-3 top-[31%] -translate-x-2/4 -translate-y-2/4 cursor-pointer swiper-button-prev-1 md:-left-3">
        </div>
        <div v-if="!MobileNoSlider || !isMobile"
          class="absolute sm:-right-6 -right-3 top-[31%] -translate-x-2/4 -translate-y-2/4 cursor-pointer swiper-button-next-1 md:-right-8">
        </div>

      </ClientOnly>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const isMobile = ref(false);

const updateWidth = () => {
  isMobile.value = window.innerWidth < 768;
};

onMounted(() => {
  updateWidth();
  window.addEventListener('resize', updateWidth);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});

const props = defineProps({
  MobileNoSlider: {
    type: Boolean,
    default: false
  },
  headerText: {
    type: String,
    default: 'Why Coffee Lovers Choose Lifeboost'
  },
  slides: {
    type: Array,
    default: () => [
      {
        imgSrc: "/assets/images/aron-profile-img.jpg",
        imgAlt: "Dr Aaron Oxenrider",
        rating: "★★★★★",
        testimonial: "“Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation.",
        name: "Dr Aaron Oxenrider",
        title: "Board Certified Chiropractic Physician and Regenerative Medicine Expert",
      },
      {
        imgSrc: "/assets/images/gary-profile-img.jpg",
        imgAlt: "Dr Gary Sanchez",
        rating: "★★★★★",
        testimonial: "“Best tasting low acid coffee ever! And it’s great on your teeth!”",
        name: "Dr Gary Sanchez",
        title: "Board Certified Dentist",
      },
      {
        imgSrc: "/assets/images/joseph-profile-img.jpg",
        imgAlt: "Joseph R. Feste",

        testimonial: "“Lifeboost Coffee is one of the healthiest, smoothest coffee's I've ever had. The ultra low acidity makes it perfect for those with stomach issues and digestive problems. Couple that with the rich, full bodied flavor and it's a treat I look forward to every day.”",
        name: "Joseph R. Feste, M.D., FACOG, AACS, AACG",
        title: "Natural Bio Health Hormones & Weight Loss.",
      },
      {
        imgSrc: "/assets/images/shaun-profile-img.jpg",
        imgAlt: "Shaun Hadsall",

        testimonial: "\"Lifeboost is by far the smoothest, most delicious coffee I've ever tasted. Whether I'm using intermittent fasting or just need a burst of energy and focus for my intense work load, Lifeboost delivers the cleanest, purest coffee energy you can find. I look forward to my daily cup (or two) each day to help boost my immune health and increase my productivity.\"",
        name: "Shaun Hadsall",
        title: "Owner of GetLeanAfter40",
      },
      {
        imgSrc: "/assets/images/john-profile-img.jpg",
        imgAlt: "John Rowley",

        testimonial: "\"Wow! This coffee is incredible! Super smooth and the lowest acid coffee I've ever drank. It doesn't hurt my stomach at all! Careful though, it goes down really fast! It's my perfect way to start out my morning with a cool smooth burst of energy. Thanks Dr Charles!\"",
        name: "John Rowley",
        title: "America's Lifestyle Strategist, Best Selling Author and Speaker",
      },
    ],
  },
});


defineBuilderComponent({
  friendlyName: "Swiper Testimonials",
  inputs: [
    {
      name: "MobileNoSlider",
      type: "boolean",
      friendlyName: "Disable Slider on Mobile",
      defaultValue: false
    },
    {
      name: "headerText",
      type: "richText",
      friendlyName: "Header Text",
      defaultValue: "Why Coffee Lovers Choose Lifeboost"
    },
    {
      name: "slides",
      type: "list",
      friendlyName: "Testimonial Slides",
      subFields: [
        {
          name: "imgSrc",
          type: "file",
          friendlyName: "Profile Image",
          allowedFileTypes: [
            "jpeg",
            "jpg",
            "png",
            "svg",
            "webp"
          ],
          defaultValue: "/assets/images/aron-profile-img.jpg"
        },
        {
          name: "imgAlt",
          type: "text",
          friendlyName: "Image Alt Text",
          defaultValue: "Profile image"
        },
        {
          name: "testimonial",
          type: "longText",
          friendlyName: "Testimonial Text",
          defaultValue: "“Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation."
        },
        {
          name: "name",
          type: "text",
          friendlyName: "Name",
          defaultValue: "Dr Aaron Oxenrider"
        },
        {
          name: "title",
          type: "text",
          friendlyName: "Job Title",
          defaultValue: "Board Certified Chiropractic Physician and Regenerative Medicine Expert"
        }
      ],
      defaultValue: [
        {
          imgSrc: "/assets/images/aron-profile-img.jpg",
          imgAlt: "Dr Aaron Oxenrider",
          testimonial: "“Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation.",
          name: "Dr Aaron Oxenrider",
          title: "Board Certified Chiropractic Physician and Regenerative Medicine Expert"
        },
        {
          imgSrc: "/assets/images/gary-profile-img.jpg",
          imgAlt: "Dr Gary Sanchez",
          testimonial: "“Best tasting low acid coffee ever! And it’s great on your teeth!”",
          name: "Dr Gary Sanchez",
          title: "Board Certified Dentist"
        },
        {
          imgSrc: "/assets/images/joseph-profile-img.jpg",
          imgAlt: "Joseph R. Feste",
          testimonial: "“Lifeboost Coffee is one of the healthiest, smoothest coffee's I've ever had. The ultra low acidity makes it perfect for those with stomach issues and digestive problems. Couple that with the rich, full bodied flavor and it's a treat I look forward to every day.”",
          name: "Joseph R. Feste, M.D., FACOG, AACS, AACG",
          title: "Natural Bio Health Hormones & Weight Loss."
        },
        {
          imgSrc: "/assets/images/shaun-profile-img.jpg",
          imgAlt: "Shaun Hadsall",
          testimonial: "\"Lifeboost is by far the smoothest, most delicious coffee I've ever tasted. Whether I'm using intermittent fasting or just need a burst of energy and focus for my intense work load, Lifeboost delivers the cleanest, purest coffee energy you can find. I look forward to my daily cup (or two) each day to help boost my immune health and increase my productivity.\"",
          name: "Shaun Hadsall",
          title: "Owner of GetLeanAfter40"
        },
        {
          imgSrc: "/assets/images/john-profile-img.jpg",
          imgAlt: "John Rowley",
          testimonial: "\"Wow! This coffee is incredible! Super smooth and the lowest acid coffee I've ever drank. It doesn't hurt my stomach at all! Careful though, it goes down really fast! It's my perfect way to start out my morning with a cool smooth burst of energy. Thanks Dr Charles!\"",
          name: "John Rowley",
          title: "America's Lifestyle Strategist, Best Selling Author and Speaker"
        }
      ]
    }
  ]
});
</script>

<style scoped>
.testimonials .swiper-wrapper {
  width: 100%;
  height: auto;
}

.testimonials .swiper-button-next {
  @apply !text-productTitle sm-max:pl-2 pt-8
}

.testimonials .swiper-button-prev {
  @apply !text-productTitle sm-max:pr-2 pt-8
}

.swiper-button-next:after, .swiper-button-prev:after {
  content: '';
}

.testimonials .swiper-button-next-1:after,
.testimonials .swiper-button-prev-1:after {
  content: url('/assets/images/arrow-swiper-new.svg');
  /* Optional: Adjust the size, position, etc. as needed */
  width: 24px;
  height: 30px;
  color: #956449 !important;
  ;
  display: inline-block;

}

.testimonials .swiper-button-next-1:after {
  transform: rotate(180deg);
  position: relative;
  bottom: 5px;
}
</style>